import { observer } from 'mobx-react-lite'
import React, { useState } from 'react'
import { Button } from 'shared/ui'
import { SettingsCard } from 'shared/ui/SettingsCard'
import { QuietHoursSettingsCard } from 'entities/QuietHours'
import { type CampaignSettingsStore } from '../store/CampaignSettingsStore'
import styles from './styles.module.scss'

type ICampaignSettingsUiProps = {
  store: CampaignSettingsStore
}

export const CampaignSettingsUi = observer(({ store }: ICampaignSettingsUiProps) => {
  const {
    onSave,
    onCancel,
    isUnEnroll,
    isReEnter,
    isQuiteHours,
    isQuietHoursEnabled,
    isQuietHoursBlockOnWeekend,
    quietHoursAllowedTimeFrom,
    quietHoursAllowedTimeTo,
    isShowQuietHours,
  } = store

  const [isUnEnrollLocal, setUnEnrollLocal] = useState(isUnEnroll)
  const [isReEnterLocal, setReEnterLocal] = useState(isReEnter)
  const [isEnableQuietHoursLocal, setEnableQuietHoursLocal] = useState(isQuiteHours)

  const handleSave = () => {
    onSave({
      isUnEnroll: isUnEnrollLocal,
      isReEnter: isReEnterLocal,
      isQuiteHours: isEnableQuietHoursLocal,
    })
  }

  return (
    <div className={styles.wrap}>
      <div className={styles.content}>
        <SettingsCard
          title={'Unenroll on SMS response'}
          desc={
            <>
              If contact replies to any message from this campaign <br />-{'>'} unenroll from
              campaign
            </>
          }
          value={isUnEnrollLocal}
          setValue={setUnEnrollLocal}
        />
        <SettingsCard
          title={'Re-enter Campaign'}
          desc={
            <>
              If a contact completed this campaign, they can be allowed to re-
              <br /> enter it again
            </>
          }
          value={isReEnterLocal}
          setValue={setReEnterLocal}
        />
        {isShowQuietHours && (
          <QuietHoursSettingsCard
            isQuietHoursEnabled={isQuietHoursEnabled}
            isQuietHoursBlockOnWeekend={isQuietHoursBlockOnWeekend}
            quietHoursAllowedTimeFrom={quietHoursAllowedTimeFrom}
            quietHoursAllowedTimeTo={quietHoursAllowedTimeTo}
            value={isEnableQuietHoursLocal}
            setValue={setEnableQuietHoursLocal}
          />
        )}
      </div>
      <div className={styles.actions}>
        <Button text={'Save'} size={'medium'} contained={'primary'} onClick={handleSave} />
        <Button text={'Cancel'} size={'medium'} contained={'secondary'} onClick={onCancel} />
      </div>
    </div>
  )
})
